/**
 * Returns an optimized image URL using Supabase Storage's image transformation
 * (renders WebP and resizes server-side). For non-Supabase URLs, returns as-is.
 *
 * Docs: https://supabase.com/docs/guides/storage/serving/image-transformations
 */
export function optimizedImage(
  url: string | null | undefined,
  opts: { width: number; height: number; quality?: number } = { width: 192, height: 192 }
): string {
  if (!url) return "";
  // Only transform Supabase Storage public URLs
  if (!url.includes("/storage/v1/object/public/")) return url;
  const transformed = url.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/"
  );
  const params = new URLSearchParams({
    width: String(opts.width),
    height: String(opts.height),
    resize: "contain",
    quality: String(opts.quality ?? 80),
  });
  return `${transformed}?${params.toString()}`;
}
